<template>
  <v-container>
    <h1 class="display-1" style="margin-bottom: 1rem;">
      {{ set.Bezeichnung }}
    </h1>
    <v-layout row align-center justify-space-between mb-4>
      <v-flex xs2 mr-3 v-if="imgPath(set)">
        <img class="set-img" :src="imgPath(set)" />
      </v-flex>
      <v-flex xs6>
        <div>
          Verfahren:
          <router-link
            :to="{ name: 'SetsMainPage', query: { v: set.Verfahren } }"
            >{{ set.Verfahren }}</router-link
          >
        </div>
        <div>Produktarten: {{ produktarten }}</div>
        <div>Sektoren: {{ sektoren }}</div>
      </v-flex>
      <v-flex xs2 text-xs-right>
        <v-btn color="info" @click="edit">Ändern</v-btn>
      </v-flex>
    </v-layout>
    <v-layout align-center justify-space-between mb-4>
      <v-flex xs4>
        <v-select
          :items="standorte"
          item-text="Standort"
          item-value="StandortID"
          label="Prüfungszentrum"
          v-model="selectedStandort"
        ></v-select>
      </v-flex>
      <v-flex xs4>
        <v-checkbox
          v-model="onlyUnlocked"
          label="nur freigegebene Stücke anzeigen"
        />
      </v-flex>
      <v-flex xs3 text-xs-right>
        <v-btn @click="createPs">Neues Prüfungsstück</v-btn>
      </v-flex>
    </v-layout>
    <v-layout align-center justify-space-between mb-4>
      <v-flex xs12>
        <v-data-table
          :loading="isLoading"
          :headers="headers"
          :items="filteredItems"
          item-key="item.ID"
          no-data-text="Keine Prüfungsstücke vorhanden"
          hide-actions
          class="elevation-1"
        >
          <template slot="items" slot-scope="props">
            <td>
              <v-icon small color="red" v-if="props.item.Gesperrt"
                >block</v-icon
              >
            </td>
            <td>{{ props.item.PrfStkNr }}</td>
            <td>
              <div v-if="props.item.usage">
                <div class="bar">
                  <span class="bar__value">{{ props.item.usage.total }}</span>
                  <div
                    class="bar__fill bar__fill--primary"
                    :style="{
                      width: getWidth(props.item.usage.total, maxTotal)
                    }"
                  ></div>
                </div>
              </div>
            </td>
            <td>
              <div v-if="props.item.usage">
                <div class="bar">
                  <span class="bar__value">{{
                    props.item.usage.last12Months
                  }}</span>
                  <div
                    class="bar__fill bar__fill--alt"
                    :style="{
                      width: getWidth(props.item.usage.last12Months, maxLast12)
                    }"
                  ></div>
                </div>
              </div>
            </td>
            <td>
              {{ props.item.standort }}
              <span v-if="props.item.aktuellerOrt"
                >({{ props.item.aktuellerOrt }})</span
              >
            </td>
            <td class="justify-center layout px-0">
              <v-btn
                flat
                icon
                color="indigo"
                class="mx-0"
                @click="editPs(props.item)"
              >
                <v-icon>edit</v-icon>
              </v-btn>
            </td>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import sortby from 'lodash.sortby';
import uniq from 'lodash.uniq';
import utils from '@/utils.js';

export default {
  name: 'SingleSetPage',
  props: ['setId'],
  data() {
    return {
      isLoading: true,
      loadingProgress: 0,
      standorte: [],
      set: {},
      headers: [
        { value: 'Gesperrt', sortable: false },
        { text: 'PrfStkNr', value: 'PrfStkNr', sortable: true },
        { text: 'Verwendungen', value: 'usage.total', sortable: true },
        {
          text: 'Letzte 12 Monate',
          value: 'usage.last12Months',
          sortable: true
        },
        { text: 'Standort', value: 'standort', sortable: true },
        { sortable: false }
      ],
      items: [],
      maxTotal: 0,
      maxLast12: 0,
      onlyUnlocked: true,
      selectedStandort: {}
    };
  },
  mounted() {
    this.loadData(this.setId);
  },
  methods: {
    async loadData(setId) {
      try {
        this.isLoading = true;

        const [set, items, stats, standorte] = await Promise.all([
          this.$http.get(`pruefungsset/${setId}`),
          this.$http.get(`pruefungsstueck?setId=${setId}`),
          this.$http.get(`pruefungsstueck/stats?setId=${setId}`),
          this.$http.get(`standort`)
        ]);

        this.maxTotal = Math.max(...stats.body.map(m => m.total));
        this.maxLast12 = Math.max(...stats.body.map(m => m.last12Months));

        var presentids = uniq(items.body.map(m => m.standortID));
        var tmpStandorte = [{ StandortID: -1, Standort: 'Alle' }];
        var availablestandorte = standorte.body.filter(
          f => presentids.indexOf(f.StandortID) > -1
        );

        tmpStandorte.push(...sortby(availablestandorte, ['Standort']));

        this.standorte = tmpStandorte;
        this.set = set.body;
        this.items = items.body.map(m => {
          m.usage = stats.body.find(f => f.ID === m.ID);
          m.standort = this.standorte.find(
            f => f.StandortID === m.standortID
          ).Standort;

          return m;
        });

        var urlStandort = this.$route.query.s;

        if (urlStandort) {
          this.selectedStandort = this.standorte.find(
            f => f.Standort.toLowerCase() === urlStandort.toLowerCase()
          ).StandortID;
        }
      } catch (err) {
        console.error(err);
      } finally {
        this.isLoading = false;
      }
    },
    edit() {
      this.$router.push({ name: 'EditSet', params: { setId: this.setId } });
    },
    createPs() {
      this.$router.push({
        name: 'CreatePrüfungsstück',
        query: { setId: this.setId }
      });
    },
    editPs(psItem) {
      this.$router.push({
        name: 'EditPrüfungsstück',
        params: { psId: psItem.ID }
      });
    },
    getWidth(val, tot) {
      return parseInt((val / tot) * 100) + '%';
    },
    imgPath(set) {
      if (set && set.img) {
        return utils.getImagePath(this.$http.options.root, set.img);
      }
      return null;
    }
  },
  computed: {
    produktarten() {
      return (this.set.produktarten || [])
        .map(m => `${m.Bezeichnung} (${m.ID})`)
        .join(', ');
    },
    sektoren() {
      return (this.set.industriesektoren || []).map(m => m.Kürzel).join(', ');
    },
    filteredItems() {
      var result = this.items;

      if (this.onlyUnlocked) {
        result = result.filter(f => !f.Gesperrt);
      }

      if (this.selectedStandort && this.selectedStandort > 0) {
        result = result.filter(f => f.standortID === this.selectedStandort);
      }
      return result;
    }
  }
};
</script>

<style scoped>
.stats-table {
  border-collapse: collapse;
  border-spacing: 6px 0;
  width: 100%;
}

.stats-table thead tr th {
  border-bottom: 2px solid #bbb;
  padding: 3px;
}

.stats-table tbody tr td {
  border-bottom: 1px solid #ddd;
  padding: 3px;
}

.bar {
  position: relative;
}

.bar__fill {
  background-color: #ffcc33;
  display: inline-block;
  height: 22px;
  float: left;
}

.bar__fill--primary {
  background: #a5c956; /* Old browsers */
  background: -moz-linear-gradient(
    left,
    #a5c956 0%,
    #cdeb8e 100%
  ); /* FF3.6-15 */
  background: -webkit-linear-gradient(
    left,
    #a5c956 0%,
    #cdeb8e 100%
  ); /* Chrome10-25,Safari5.1-6 */
  background: linear-gradient(
    to right,
    #a5c956 0%,
    #cdeb8e 100%
  ); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#a5c956', endColorstr='#cdeb8e',GradientType=1 ); /* IE6-9 */
}

.bar__fill--alt {
  background: #05abe0; /* Old browsers */
  background: -moz-linear-gradient(
    left,
    #05abe0 0%,
    #53cbf1 60%,
    #87e0fd 100%
  ); /* FF3.6-15 */
  background: -webkit-linear-gradient(
    left,
    #05abe0 0%,
    #53cbf1 60%,
    #87e0fd 100%
  ); /* Chrome10-25,Safari5.1-6 */
  background: linear-gradient(
    to right,
    #05abe0 0%,
    #53cbf1 60%,
    #87e0fd 100%
  ); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#05abe0', endColorstr='#87e0fd',GradientType=1 ); /* IE6-9 */
}

.bar__value {
  position: absolute;
  right: 2px;
}

.set-img {
  max-height: 124px;
  max-width: 210px;
}
</style>
